import React from 'react';
import { Switch, Route, useLocation, useRouteMatch, matchPath } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';

import Page from 'components/Page';
import PageContainer from 'components/PageContainer';
import joinPath from 'utilities/joinPath';

import Categories from './Categories';
import UnitType from './UnitType';


const ApartmentTypesTemplate = () => {
    const location = useLocation();
    const match = useRouteMatch();

    const unitTypePathPattern = joinPath(match.path, ':categorySlug', ':unitTypeSlug');

    const isUnit = matchPath(location.pathname, {
        path: unitTypePathPattern,
        exact: true,
    });
    
    return (
        <Page>
            <PageContainer>
                <AnimatePresence>
                    <Switch location={location} key={isUnit ? 'unit' : 'categories'}>
                        <Route path={unitTypePathPattern}>
                            <UnitType/>
                        </Route>
                        <Route path={match.path}>
                            <Categories />
                        </Route>
                    </Switch>
                </AnimatePresence>
            </PageContainer>
        </Page>
    );
};


export default ApartmentTypesTemplate;
